<!-- Post Input Card -->
<div class="card shadow-sm mb-3 post-input-card"  *ngIf="!IsRecruiter">
  <div class="d-flex align-items-center mb-3">
    <img [src]="profilePhoto" class="rounded-circle me-3" width="50" height="50" alt="Profile" />
    <input type="text" class="form-control post-text-input"
           placeholder="Start a post..." (click)="openModal()" readonly />
  </div>
  <div class="d-flex justify-content-start gap-3">
    <button class="btn btn-lite-blue px-3 py-2 rounded-pill" (click)="openModal()">
      <i class="bi bi-image me-1"></i> Add Photo
    </button>
  </div>
</div>

<div class="card shadow-sm mb-3 post-input-card" *ngIf="IsRecruiter">
  <div class="row g-2">
    <!-- Regular post -->
    <div class="col-12 col-md-6">
      <div
        class="d-flex align-items-center post-input-row"
        tabindex="0"
        (click)="openModal()"
        (keydown.enter)="openModal()"
        (keydown.space)="openModal()"
        role="button"
        aria-label="Start a post"
      >
        <img [src]="profilePhoto" class="rounded-circle me-3" width="50" height="50" alt="Profile" />
        <input
          type="text"
          class="form-control post-text-input"
          placeholder="Start a post..."
          readonly
        />
      </div>
    </div>

    <!-- Job post -->
    <div class="col-12 col-md-6"  *ngIf="!isKARecruiter" >
      <div
        class="d-flex align-items-center post-input-row"
        tabindex="0"
        (click)="openJobPostModal()"
        (keydown.enter)="openJobPostModal()"
        (keydown.space)="openJobPostModal()"
        role="button"
        aria-label="Post a Requirement"
      >
        <div class="me-3 d-flex align-items-center justify-content-center rounded-circle icon-wrap" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor">
            <path d="M6 1.5A1.5 1.5 0 0 1 7.5 0h1A1.5 1.5 0 0 1 10 1.5V3h3a2 2 0 0 1 2 2v2.5h-4V6.5a.5.5 0 0 0-1 0V7.5H6V6.5a.5.5 0 0 0-1 0V7.5H1V5a2 2 0 0 1 2-2h3V1.5zM9 3V1.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V3h2z"/>
            <path d="M0 8.5V13a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.5H9V9.5a.5.5 0 0 1-1 0V8.5H0z"/>
          </svg>
        </div>
        <input
          type="text"
          class="form-control post-text-input"
          placeholder="Post a Requirement"
          readonly
        />
      </div>
    </div>
  </div>
</div>



<!-- Modal -->
<div class="modal fade show d-block custom-modal" *ngIf="showModal">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content" [ngClass]="{ 'fade-out': isFadingOut }">
      <div class="modal-header border-bottom-0">
        <h5 class="modal-title heading-blue">Create a Post</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="postForm" (ngSubmit)="submitPost()">
          <textarea
          rows="5"
          formControlName="content"
          maxlength="1000"
          (input)="onContentInput()"
          class="form-control mb-3 border-0 shadow-sm text-gray"
          placeholder="What do you want to talk about?"
          style="resize: none;"
        ></textarea>
        <small class="text-end d-block text-muted">
          {{ postForm.value.content?.length || 0 }}/1000 characters
        </small>
        

          <div class="mb-3">
            <label class="form-label heading-blue">Add up to 5 images</label>
            <input type="file" accept="image/*" multiple (change)="onFileChange($event)" class="form-control" />
            <small class="text-danger" *ngIf="imageError">{{ imageError }}</small>

            <div class="mt-3 d-flex flex-wrap gap-2">
              <div
                *ngFor="let img of imagePreviews; let i = index"
                class="position-relative image-preview-wrapper"
              >
                <img
                  [src]="img"
                  class="preview-image"
                  (click)="openImageViewer(imagePreviews, i)"
                />
                <button
                  type="button"
                  class="btn btn-sm btn-danger delete-btn"
                  (click)="removeImage(i)"
                  title="Remove"
                >
                  ×
                </button>
            
                <div
                  *ngIf="imageLoading[i]"
                  class="position-absolute top-50 start-50 translate-middle"
                >
                  <div class="spinner-border text-primary spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
            
            
          </div>

          <button
          type="submit"
          class="btn btn-lite-blue w-100"
          [disabled]="isSubmitting || (!postForm.value.content.trim() && selectedImages.length === 0)">
          {{ isSubmitting ? 'Posting...' : 'Post' }}
        </button>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Image Viewer Modal -->
<ng-template #imageModal let-modal>
  <div class="modal-body text-center p-0">
    <img
      [src]="imageViewer?.current"
      class="img-fluid w-100 swipe-img"
      style="cursor: pointer;"
      (swipeleft)="nextImage()"
      (swiperight)="prevImage()"
    />
  </div>
  <div class="modal-footer justify-content-between border-0">
    <button class="btn btn-link" (click)="prevImage()" [disabled]="!hasPrev()">Prev</button>
    <button class="btn btn-link" (click)="nextImage()" [disabled]="!hasNext()">Next</button>
    <button class="btn btn-danger btn-sm" (click)="imageModalRef?.close()">Close</button>
  </div>
</ng-template>

<!-- Job Post Modal -->
<div class="modal fade show d-block custom-modal" *ngIf="showJobPostModal">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content" [ngClass]="{ 'fade-out': isPostFadingOut }">
      <div class="modal-header border-bottom-0">
        <h5 class="modal-title heading-blue">Create a Requirement</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeJobPostModal()"></button>
      </div>
      <div class="modal-header border-bottom-0" style="margin-top: -2% !important;">
        <h6 class="modal-title heading-gray">Feel free to post as many times as you need - just keep each post focused on one requirement to get better applicants.</h6>
      </div>

      <div class="modal-body">
        <form [formGroup]="jobPostForm" (ngSubmit)="submitJobPost()">
          <!-- Designation -->
          <div class="mb-3">
            <label for="jpDesignation" class="form-label heading-blue">
              Designation <span class="text-danger">*</span>
            </label>
            <input
              id="jpDesignation"
              type="text"
              class="form-control shadow-sm"
              formControlName="designation"
              placeholder="Input Requirement Designation..."
            />
            <div class="text-danger mt-1" *ngIf="jobPostForm.get('designation')?.touched && jobPostForm.get('designation')?.errors">
              <small *ngIf="jobPostForm.get('designation')?.hasError('required')">Designation is required.</small>
              <small *ngIf="jobPostForm.get('designation')?.hasError('hasUrlEmail')">URLs and emails are not allowed.</small>
            </div>
          </div>

          <!-- Description (optional) -->
          <div class="mb-3">
            <label for="jpDescription" class="form-label heading-blue">Description (optional)</label>
            <textarea
              id="jpDescription"
              rows="4"
              class="form-control shadow-sm"
              formControlName="description"
              placeholder="Input Description..."
              style="resize: none;"
            ></textarea>
            <div class="text-danger mt-1" *ngIf="jobPostForm.get('description')?.touched && jobPostForm.get('description')?.hasError('hasUrlEmail')">
              <small>We block links so candidates stay here, because we want to give you CV+Availability in one place so you can hire faster.</small>
            </div>
          </div>

          <!-- Location + Start Date -->
          <div class="row g-2">
            <div class="col-12 col-md-6 mb-3">
              <label for="jpLocation" class="form-label heading-blue">
                Location <span class="text-danger">*</span>
              </label>
              <input
                id="jpLocation"
                type="text"
                class="form-control shadow-sm"
                formControlName="location"
                placeholder="Input Location..."
              />
              <div class="text-danger mt-1" *ngIf="jobPostForm.get('location')?.touched && jobPostForm.get('location')?.hasError('required')">
                <small>Location is required.</small>
              </div>
            </div>

            <div class="col-12 col-md-6 mb-3">
              <label for="jpStartDate" class="form-label heading-blue">
                Start date <span class="text-danger">*</span>
              </label>
              <input
                id="jpStartDate"
                type="date"
                class="form-control shadow-sm"
                formControlName="start_date"
              />
              <div class="text-danger mt-1" *ngIf="jobPostForm.get('start_date')?.touched && jobPostForm.get('start_date')?.hasError('required')">
                <small>Start date is required.</small>
              </div>
            </div>
          </div>

          <!-- Duration (free text) -->
       <!-- Duration (value + unit) -->
<div class="mb-4">
  <label class="form-label heading-blue">
    Duration <span class="text-danger">*</span>
  </label>

  <div class="row g-2">
    <!-- Number -->
    <div class="col-6">
      <select
        id="jpDurationValue"
        class="form-select shadow-sm"
        formControlName="duration_value"
        aria-label="Duration value"
      >
        <option [ngValue]="null" disabled selected>Select number…</option>
        <option *ngFor="let n of durationNumbers" [value]="n">{{ n }}</option>
      </select>
      <div class="text-danger mt-1"
           *ngIf="jobPostForm.get('duration_value')?.touched && jobPostForm.get('duration_value')?.errors">
        <small *ngIf="jobPostForm.get('duration_value')?.hasError('required')">Value is required.</small>
        <small *ngIf="jobPostForm.get('duration_value')?.hasError('min')">Must be at least 1.</small>
      </div>
    </div>

    <!-- Unit -->
    <div class="col-6">
      <select
        id="jpDurationUnit"
        class="form-select shadow-sm"
        formControlName="duration_unit"
        aria-label="Duration unit"
      >
        <option value="" disabled selected>Select unit…</option>
        <option value="days">Days</option>
        <option value="weeks">Weeks</option>
        <option value="months">Months</option>
      </select>
      <div class="text-danger mt-1"
           *ngIf="jobPostForm.get('duration_unit')?.touched && jobPostForm.get('duration_unit')?.hasError('required')">
        <small>Unit is required.</small>
      </div>
    </div>
  </div>
</div>


          <!-- Submit -->
          <button type="submit" class="btn btn-lite-blue w-100" [disabled]="isSubmitting || jobPostForm.invalid">
            {{ isSubmitting ? 'Posting...' : 'Post' }}
          </button>
        </form>
      </div>
    </div>
  </div>
</div>

